import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from '../../../../models/users/user';
import { UserService } from '../../../../models/users/userService';

@Component({
  selector: 'app-impersonate-chooser-dialog',
  templateUrl: './impersonate-chooser-dialog.component.html',
  standalone: false,
})
export class ImpersonateChooserDialogComponent {
  merchantId: string;
  users: User[] | undefined;

  constructor(
    public dialogRef: MatDialogRef<ImpersonateChooserDialogComponent>,
    public userService: UserService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      merchantId: string;
    },
  ) {
    // get available users

    this.merchantId = data.merchantId;

    userService.getPaged('', data.merchantId, '').then((response) => {
      if (response.records.length == 1) {
        this.selectUser(response.records[0].id);
      } else {
        this.users = response.records;
      }
    });
  }

  selectUser(userId: string) {
    this.userService.impersonateUser(userId);

    this.dialogRef.close(userId);
  }
}
